module.exports = __webpack_public_path__ + "static/media/neko-young-result-2.7ab5e962.png";